<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <h3 class="text-center">提现方式</h3>
      <el-form ref="form" :model="form" :rules="rules" class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <el-form-item label="" prop="">
          <YueDanIpt model="name" :object="form" :placeholder="namePlaceholder" :focus="true"></YueDanIpt>
        </el-form-item>
        <el-form-item label="" prop="card_number">
          <YueDanIpt model="card_number" :object="form" :placeholder="type"></YueDanIpt>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="block" type="primary" @click="submit()" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import YueDanIpt from '../../../components/YueDanIpt'


export default {
  name: 'AddAddress',
  props: ['item'],
  components: {
    YueDanIpt: YueDanIpt
  },
  data () {
    return {
      readonly: false,
      dialogFormVisible: false,
      loading: false,
      errors: null,
      isEmptyErrors: true,
      type: null,
      namePlaceholder: null,
      form: {
        name: '',
        card_number: ''
      },
      rules: {
        card_number: [
          { required: true, message: '账号是必填项', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.readonly = false
      this.form = {
        name: '',
        card_number: ''
      }
      this.isEmptyErrors = true
    },
    show () {
      this.dialogFormVisible = true
      this.form.withdraw_type_id = this.item.id
      Object.assign(this.form, this.item)
      switch (Number(this.form.type)) {
        case 3:
          this.type = '支付宝账号'
          this.namePlaceholder = '支付宝认证姓名'
          break
        default:
          this.type = 'Paypal账号'
          this.namePlaceholder = 'Paypal认证姓名'
      }
    },
    submit () {
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors
        if (valid) {
          let res = await api.post(this, {
            path: 'single.php',
            api: this.form.id ? 'update_withdraw_type': 'add_withdraw_type',
            data: this.form,
            loading: 'loading'
          })
          if (res.body.status == 'ok') {
            this.$emit('success')
            this.init()
            this.dialogFormVisible = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/single_user_center/components/WithdrawType.vue